module.exports = __webpack_public_path__ + "img/7.cc14854a.jpg";